'use client';

import React, { useCallback } from 'react';
import { useVariantSelection, Variant } from './VariantSelectionContext';
import styles from './VariantSelectionBar.module.css';

const VariantSelectionBar: React.FC = () => {
  const { selectedVariant, setSelectedVariant, handleBuyClick } =
    useVariantSelection();

  const handleVariantClick = useCallback(
    (variant: Variant) => {
      setSelectedVariant(variant);
    },
    [setSelectedVariant],
  );

  return (
    <div className={styles.stickyBar}>
      <div className={styles.buttonContainer}>
        <button
          className={styles.variantButton}
          data-active={selectedVariant === 'Phantom' ? 'true' : undefined}
          onClick={() => handleVariantClick('Phantom')}
          aria-label="Select Phantom variant"
          aria-pressed={selectedVariant === 'Phantom'}
        >
          Explore Phantom
        </button>
        <button
          className={styles.variantButton}
          data-active={selectedVariant === 'Cryo' ? 'true' : undefined}
          onClick={() => handleVariantClick('Cryo')}
          aria-label="Select Cryo variant"
          aria-pressed={selectedVariant === 'Cryo'}
        >
          Explore Cryo
        </button>
        <button
          className={styles.buyButton}
          onClick={handleBuyClick}
          aria-label={`Buy ${selectedVariant} variant`}
        >
          Buy Now
        </button>
      </div>
    </div>
  );
};

export default VariantSelectionBar;
